import styled from 'styled-components';

export const PopupContent = styled.div`
  font-weight: 400;
  font-style: Regular;
  font-size: 16px;
  leading-trim: NONE;
  line-height: 24px;
  letter-spacing: 0px;
  color: ${({ theme }) => theme.colors.INK_800};

  ul {
    margin: 0;
    padding: 0;

    > li {
      display: block;
    }

    > li:before {
      content: '•';
      display: inline-block;
      vertical-align: top;
      text-align: center;
      width: 16px;
    }
  }

  ol {
    margin: 0 0 0 22px;
    padding: 0;
  }
`;
